const SDK_VERSION = '8.5.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
